export const FORM_FACTOR_REQUEST = 'FORM_FACTOR_REQUEST';
export const FORM_FACTOR_SUCCESS = 'FORM_FACTOR_SUCCESS';
export const FORM_FACTOR_FAILURE = 'FORM_FACTOR_FAILURE';

export const MODEL_COUNT_REQUEST = 'MODEL_COUNT_REQUEST';
export const MODEL_COUNT_SUCCESS = 'MODEL_COUNT_SUCCESS';
export const MODEL_COUNT_FAILURE = 'MODEL_COUNT_FAILURE';

export const WARRANTY_REQUEST = 'WARRANTY_REQUEST';
export const WARRANTY_SUCCESS = 'WARRANTY_SUCCESS';
export const WARRANTY_FAILURE = 'WARRANTY_FAILURE';

export const AGE_REQUEST = 'AGE_REQUEST';
export const AGE_SUCCESS = 'AGE_SUCCESS';
export const AGE_FAILURE = 'AGE_FAILURE';

export const UTILISATION_REQUEST = 'UTILISATION_REQUEST';
export const UTILISATION_SUCCESS = 'UTILISATION_SUCCESS';
export const UTILISATION_FAILURE = 'UTILISATION_FAILURE';

export const DEVICES_REQUEST = 'DEVICES_REQUEST';
export const DEVICES_SUCCESS = 'DEVICES_SUCCESS';
export const DEVICES_FAILURE = 'DEVICES_FAILURE';

export const DEVICE_COUNT_REQUEST = 'DEVICE_COUNT_REQUEST';
export const DEVICE_COUNT_SUCCESS = 'DEVICE_COUNT_SUCCESS';
export const DEVICE_COUNT_FAILURE = 'DEVICE_COUNT_FAILURE';

export const HOURLY_BANDWIDTH_USAGE_FETCH_REQUEST = 'HOURLY_BANDWIDTH_USAGE_FETCH_REQUEST';
export const HOURLY_BANDWIDTH_USAGE_FETCH_SUCCESS = 'HOURLY_BANDWIDTH_USAGE_FETCH_SUCCESS';

export const HOURLY_BANDWIDTH_USAGE_BY_DEPARTMENT_REQUEST = 'HOURLY_BANDWIDTH_USAGE_BY_DEPARTMENT_REQUEST';
export const HOURLY_BANDWIDTH_USAGE_BY_DEPARTMENT_SUCCESS = 'HOURLY_BANDWIDTH_USAGE_BY_DEPARTMENT_SUCCESS';
export const HOURLY_BANDWIDTH_USAGE_BY_DEPARTMENT_FAILURE = 'HOURLY_BANDWIDTH_USAGE_BY_DEPARTMENT_FAILURE';

export const HOURLY_BANDWIDTH_USAGE_BY_NON_DEPARTMENT_REQUEST = 'HOURLY_BANDWIDTH_USAGE_BY_NON_DEPARTMENT_REQUEST';
export const HOURLY_BANDWIDTH_USAGE_BY_NON_DEPARTMENT_SUCCESS = 'HOURLY_BANDWIDTH_USAGE_BY_NON_DEPARTMENT_SUCCESS';
export const HOURLY_BANDWIDTH_USAGE_BY_NON_DEPARTMENT_FAILURE = 'HOURLY_BANDWIDTH_USAGE_BY_NON_DEPARTMENT_FAILURE';

export const NUMBER_OF_HITS_REQUEST = 'NUMBER_OF_HITS_REQUEST';
export const NUMBER_OF_HITS_SUCCESS = 'NUMBER_OF_HITS_SUCCESS';
export const NUMBER_OF_HITS_FAILURE = 'NUMBER_OF_HITS_FAILURE';

export const BANDWIDTH_USAGE_REQUEST = 'BANDWIDTH_USAGE_REQUEST';
export const BANDWIDTH_USAGE_SUCCESS = 'BANDWIDTH_USAGE_SUCCESS';
export const BANDWIDTH_USAGE_FAILURE = 'BANDWIDTH_USAGE_FAILURE';

export const BUILD_NUMBER_COUNT_REQUEST = 'BUILD_NUMBER_COUNT_REQUEST';
export const BUILD_NUMBER_COUNT_SUCCESS = 'BUILD_NUMBER_COUNT_SUCCESS';
export const BUILD_NUMBER_COUNT_FAILURE = 'BUILD_NUMBER_COUNT_FAILURE';

export const OPERATING_SYSTEM_COUNT_REQUEST = 'OPERATING_SYSTEM_COUNT_REQUEST';
export const OPERATING_SYSTEM_COUNT_SUCCESS = 'OPERATING_SYSTEM_COUNT_SUCCESS';
export const OPERATING_SYSTEM_COUNT_FAILURE = 'OPERATING_SYSTEM_COUNT_FAILURE';
